class ReceiptUpload extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const reader = new FileReader()

    this.querySelector('#file-upload').addEventListener(
      'change',
      handleFileSelect.bind(this)
    )
    this.querySelector('#file-drag').addEventListener(
      'dragover',
      handleDragOver.bind(this)
    )
    this.querySelector('#file-drag').addEventListener(
      'drop',
      handleFileDrop.bind(this)
    )

    function handleFileSelect() {
      const fileInput = this.querySelector('#file-upload')
      const preview = this.querySelector('#file-preview')
      const file = fileInput.files[0]
      preview.classList.remove('hidden')
      const reader = new FileReader()
      reader.onload = function () {
        // Set the src attribute of the preview image to the result of the FileReader
        preview.src = reader.result
      }
      reader.readAsDataURL(file)
    }

    function handleDragOver(event) {
      event.preventDefault()
    }

    function handleFileDrop(event) {
      event.preventDefault()
      const preview = this.querySelector('#file-preview')
      const file = event.dataTransfer.files[0]
      preview.classList.remove('hidden')
      const reader = new FileReader()
      reader.onload = function () {
        // Set the src attribute of the preview image to the result of the FileReader
        preview.src = reader.result
      }
      reader.readAsDataURL(file)
    }

    this.querySelector('#camera-upload').addEventListener('change', () => {
      const fileInput = this.querySelector('#camera-upload')
      const preview = this.querySelector('#camera-preview')
      const file = fileInput.files[0]
      preview.classList.remove('hidden')
      reader.onload = function () {
        // Set the src attribute of the preview image to the result of the FileReader
        preview.src = reader.result
      }
      reader.readAsDataURL(file)
    })

    this.querySelector('.submit-form').addEventListener('click', (e) => {
      e.preventDefault()
      const cameraInput = this.querySelector('#camera-upload')
      const fileInput = this.querySelector('#file-upload')
      const form = this.querySelector('.receipt-form')
      const errorDiv = this.querySelector('#error-div')

      if (!cameraInput.files.length && !fileInput.files.length) {
        errorDiv.innerText = 'Please select a file or take a picture'
        return
      } else {
        form.submit()
      }
    })
  }
}
customElements.define('receipt-upload', ReceiptUpload)
